// import React, { useEffect, useState } from "react";
// import axiosInstance from "../../Api/axios.instance";

// const drilldowncomplianceMap = {
//   //1: 47, // Schools
//   1: 373, // Schools
//   2: 374, // Students
//   3: 375, // Parents
//   4: 376, // Orphans
//   5: 377, // Zakat Deserving
//   6: 378, // Missing CNIC
//   7: 379, // Principals
//   8: 380, // Teachers
//   9: 381, // Non-Teaching
//  10: 382, // Teacher Observation
//  11: 383, // Admissions
//  12: 384, // Dropouts
//  13: 385, // Monthly Fees Collection Details
//  14: 386, // All Fee Heads Collection Details
//  15: 387, // Underprivileged Students
//  16: 388, // Student Age Below Four
//  17: 389, // PTM
//  18: 390, // Tasks
//  19: 391,  // Student by Gender
//  20: 392,  // Students by Class
// };

// const cardPositions = {
//   1: { top: "2.8%", left: "1.5%", width: "24%", height: "10%" },   // Students Previous Schools
//   2: { top: "2.8%", left: "26%", width: "24%", height: "10%" },    // Parents
//   3: { top: "2.8%", left: "50.5%", width: "24%", height: "10%" },  // Orphans
//   4: { top: "2.8%", left: "75%", width: "24%", height: "10%" },    // Zakat Deserving

//   5: { top: "13%", left: "1.5%", width: "24%", height: "10%" },  // Missing CNIC
//   6: { top: "13%", left: "26%", width: "24%", height: "10%" },   // Principal
//   7: { top: "13%", left: "50.5%", width: "24%", height: "10%" }, // Teachers
//   8: { top: "13%", left: "75%", width: "24%", height: "10%" },   // Non-Teaching

//   9: { top: "23.3%", left: "1.5%", width: "24%", height: "9.8%" },  // Teacher Observation
//  10: { top: "23.3%", left: "26%", width: "24%", height: "9.8%" },   // Admission From July
//  11: { top: "23.3%", left: "50.5%", width: "24%", height: "9.8%" }, // Dropout From July
//  12: { top: "23.3%", left: "75%", width: "24%", height: "9.8%" },   // Non-Teaching

//  13: { top: "33.5%", left: "1.5%", width: "24%", height: "9.8%" }, // Monthly Fees Collection Details
//  14: { top: "33.5%", left: "26%", width: "24%", height: "9.8%" }, // All Fee Heads Collection Details
//  15: { top: "33.5%", left: "50.5%", width: "24%", height: "9.8%" }, // Underprivileged Students
//  16: { top: "33.5%", left: "75%", width: "24%", height: "9.8%" }, // Student Age Below Four

//  17: { top: "43.55%", left: "1.5%", width: "24%", height: "9.8%" }, // PTM
//  18: { top: "43.55%", left: "26%", width: "24%", height: "9.8%" }, // Tasks

//  19: { top: "53.75%", left: "1.5%", width: "44%", height: "20%" }, // Students By Gender
//  20: { top: "53.75%", left: "47%", width: "50%", height: "20%" } // Students By Class

// };

// const ComplianceMetabase = ({ cluster }) => {
//   const [iframeUrl, setIframeUrl] = useState("");
//   const [mode, setMode] = useState("compliancedashboard"); // 'dashboard' or 'question'
//   const [dashboardType, setDashboardType] = useState("overall");

//   useEffect(() => {
//     loadcomplianceDashboard();
//   },[cluster]);

//   const loadcomplianceDashboard = () => {
//     axiosInstance
//       .get("/metabase/compliancedashboard", { params: { cluster } })
//       .then((res) => {
//         setIframeUrl(res.data.url);
//         setMode("compliancedashboard");
//       });
//   };

//   const loadcomplianceDrilldown = (cardId) => {
//     const questionId = drilldowncomplianceMap[cardId];
//     if (!questionId) return;

//     axiosInstance.get(`/metabase/compliancequestion/${questionId}`, {
//     params: { cluster }
//     })
//     .then((res) => {
//         setIframeUrl(res.data.url);
//         setMode("compliancequestion");
//       });
//   };

//   return (
//     <div style={{ position: "relative" }}>
//       {iframeUrl ? (
//         <>
//           <iframe
//             src={iframeUrl}
//             frameBorder="0"
//             width="100%"
//             height={2000}
//             allowTransparency
//             title="Metabase"
//           />
//           {mode === "compliancedashboard" &&
//             Object.entries(cardPositions).map(([cardId, pos]) => (
//               <div
//                 key={cardId}
//                 onClick={() => loadcomplianceDrilldown(cardId)}
//                 style={{
//                   position: "absolute",
//                   ...pos,
//                   zIndex: 10,
//                   cursor: "pointer",
//                 }}
//               />
//             ))}
//           {mode === "compliancequestion" && (
//             <button
//               onClick={loadcomplianceDashboard}
//               style={{
//                 position: "absolute",
//                 top: 8,
//                 right: 16,
//                 zIndex: 20,
//                 backgroundColor: "#0072BB",
//                 color: "white",
//                 padding: "8px 16px",
//                 fontSize: "10px",
//                 fontWeight: "500",
//                 border: "none",
//                 borderRadius: "6px",
//                 boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                 cursor: "pointer",
//               }}
//             >
//               ← Back to Compliance Dashboard
//             </button>
//           )}
//         </>
//       ) : (
//         <p>Loading Compliance Dashboard...</p>
//       )}
//     </div>
//   );
// };

// export default ComplianceMetabase;

import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../../Api/axios.instance";

const drilldownMap = {
  overall: {
    1: 373,
    2: 603,
    3: 374,
    4: 379,
    5: 380,
    6: 381,
    7: 390,
    8: 604,
    9: 424,
    10: 428,
    11: 616,
    12: 617,
    13: 618,
    14: 619,
    15: 620,
    16: 622,
    17: 623,
    18: 624,
    19: 607,
    20: 608,
    21: 609,
    22: 610,
  },

  cluster: {
    1: 332,
    2: 317,
    3: 321,
    4: 322,
    5: 323,
    6: 347,
    7: 425,
    8: 429,
    9: 605,
    11: 625,
    12: 628,
    13: 630,
    14: 632,
    15: 621,
    16: 634,
    17: 636,
    18: 638,
    19: 611,
    20: 612,
    21: 613,
    22: 614,
  },

  school: {
    1: 140,
    2: 141,
    3: 45,
    4: 142,
    5: 349,
    6: 606,
    11: 626,
    12: 627,
    13: 629,
    14: 631,
    15: 640,
    16: 633,
    17: 635,
    18: 637,
    19: 615,
    20: 484,
    21: 656,
    22: 483,
  },
};

const cardPositionsMap = {
  overall: {
    1: { top: "2.6%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Students Previous Schools
    2: { top: "2.6%", left: "26%", width: "23.5%", height: "8.2%" }, // Parents
    3: { top: "2.6%", left: "50.5%", width: "23.5%", height: "8.2%" }, // Orphans
    4: { top: "2.6%", left: "75%", width: "23.5%", height: "8.2%" }, // Zakat Deserving

    5: { top: "11.6%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Missing CNIC
    6: { top: "11.6%", left: "26%", width: "23.5%", height: "8.2%" }, // Principal
    // 7: { top: "11.6%", left: "50.5%", width: "23.5%", height: "8.2%" }, // Teachers
    10: { top: "11.6%", left: "50.5%", width: "23.5%", height: "8.2%" },
    8: { top: "11.6%", left: "75%", width: "23.5%", height: "8.2%" }, // Non-Teaching

    9: { top: "20%", left: "1.5%", width: "23.5%", height: "8.2%" }, // Teacher Observation
    // 10: { top: "20%", left: "26%", width: "23.5%", height: "8.2%" }, // Admission From July

    11: { top: "31.3%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Dropout From July
    12: { top: "31.3%", left: "26%", width: "23.5%", height: "8.2%" }, // Non-Teaching
    13: { top: "31.3%", left: "50.5%", width: "23.5%", height: "8.2%" }, // Monthly Fees Collection Details
    14: { top: "31.3%", left: "75%", width: "23.5%", height: "8.2%" }, // All Fee Heads Collection Details

    15: { top: "40%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Underprivileged Students
    16: { top: "40%", left: "26%", width: "23.5%", height: "8.2%" }, // Student Age Below Four
    17: { top: "40%", left: "50.5%", width: "23.5%", height: "8.2%" }, // PTM
    18: { top: "40%", left: "75%", width: "23.5%", height: "8.2%" }, // Tasks

    19: { top: "51.5%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Students By Gender
    20: { top: "51.5%", left: "26%", width: "23.5%", height: "8.2%" }, // Students By Class
    21: { top: "51.5%", left: "50.5%", width: "23.5%", height: "8.2%" }, // PTM
    22: { top: "51.5%", left: "75%", width: "23.5%", height: "8.2%" }, // Tasks
  },
  cluster: {
    1: { top: "2.6%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Students Previous Schools
    2: { top: "2.6%", left: "26%", width: "23.5%", height: "8.2%" }, // Parents
    3: { top: "2.6%", left: "50.5%", width: "23.5%", height: "8.2%" }, // Orphans
    4: { top: "2.6%", left: "75%", width: "23.5%", height: "8.2%" }, // Zakat Deserving

    5: { top: "11.6%", left: "1.8%", width: "48.5%", height: "8.2%" }, // Missing CNIC
    // 6: { top: "11.6%", left: "26%", width: "23.5%", height: "8.2%" }, // Principal
    7: { top: "11.6%", left: "50.5%", width: "48.5%", height: "8.2%" }, // Teachers
    8: { top: "20%", left: "50.5%", width: "48.5%", height: "8.2%" }, // Non-Teaching

    9: { top: "20%", left: "1.8%", width: "48.5%", height: "8.2%" }, // Teacher Observation
    //10: { top: "20%", left: "26%", width: "23.5%", height: "8.2%" },   // Admission From July

    11: { top: "31.3%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Dropout From July
    12: { top: "31.3%", left: "26%", width: "23.5%", height: "8.2%" }, // Non-Teaching
    13: { top: "31.3%", left: "50.5%", width: "23.5%", height: "8.2%" }, // Monthly Fees Collection Details
    14: { top: "31.3%", left: "75%", width: "23.5%", height: "8.2%" }, // All Fee Heads Collection Details

    15: { top: "40%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Underprivileged Students
    16: { top: "40%", left: "26%", width: "23.5%", height: "8.2%" }, // Student Age Below Four
    17: { top: "40%", left: "50.5%", width: "23.5%", height: "8.2%" }, // PTM
    18: { top: "40%", left: "75%", width: "23.5%", height: "8.2%" }, // Tasks

    19: { top: "51.5%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Students By Gender
    20: { top: "51.5%", left: "26%", width: "23.5%", height: "8.2%" }, // Students By Class
    21: { top: "51.5%", left: "50.5%", width: "23.5%", height: "8.2%" }, // PTM
    22: { top: "51.5%", left: "75%", width: "23.5%", height: "8.2%" }, // Tasks
  },
  school: {
    1: { top: "2.6%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Students Previous Schools
    2: { top: "2.6%", left: "26%", width: "23.5%", height: "8.2%" }, // Parents
    3: { top: "2.6%", left: "50.5%", width: "23.5%", height: "8.2%" }, // Orphans
    4: { top: "2.6%", left: "75%", width: "23.5%", height: "8.2%" }, // Zakat Deserving

    6: { top: "11.6%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Principal
    // 5: { top: "11.6%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Missing CNIC
    // 7: { top: "11.6%", left: "50.5%", width: "23.5%", height: "8.2%" }, // Teachers
    // 8: { top: "11.6%", left: "75%", width: "23.5%", height: "8.2%" },   // Non-Teaching

    // 9: { top: "20%", left: "1.5%", width: "23.5%", height: "8.2%" },  // Teacher Observation
    // 10: { top: "20%", left: "26%", width: "23.5%", height: "8.2%" },   // Admission From July

    11: { top: "22.5%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Dropout From July
    12: { top: "22.5%", left: "26%", width: "23.5%", height: "8.2%" }, // Non-Teaching
    13: { top: "22.5%", left: "50.5%", width: "23.5%", height: "8.2%" }, // Monthly Fees Collection Details
    14: { top: "22.5%", left: "75%", width: "23.5%", height: "8.2%" }, // All Fee Heads Collection Details

    15: { top: "31.5%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Underprivileged Students
    16: { top: "31.5%", left: "26%", width: "23.5%", height: "8.2%" }, // Student Age Below Four
    17: { top: "31.5%", left: "50.5%", width: "23.5%", height: "8.2%" }, // PTM
    18: { top: "31.5%", left: "75%", width: "23.5%", height: "8.2%" }, // Tasks

    19: { top: "42.5%", left: "1.8%", width: "23.5%", height: "8.2%" }, // Students By Gender
    20: { top: "42.5%", left: "26%", width: "23.5%", height: "8.2%" }, // Students By Class
    21: { top: "42.5%", left: "50.5%", width: "23.5%", height: "8.2%" }, // PTM
    22: { top: "42.5%", left: "75%", width: "23.5%", height: "8.2%" }, // Tasks
  },
};

const ComplianceMetabase = ({ cluster, school }) => {
  const [iframeUrl, setIframeUrl] = useState("");
  const [mode, setMode] = useState("dashboard");
  const [activeTab, setActiveTab] = useState("overall");

  // useEffect(() => {
  //   loadDashboard();

  //   // const listener = (event) => {
  //   //   if (!event.data || typeof event.data !== "string") return;

  //   //   const url = event.data;

  //   //   if (url.includes("overall")) setActiveTab("overall");
  //   //   if (url.includes("cluster")) setActiveTab("cluster");
  //   //   if (url.includes("school")) setActiveTab("school");
  //   // };

  //   // window.addEventListener("message", listener);
  //   // return () => window.removeEventListener("message", listener);
  // }, [cluster, school]);

  useEffect(() => {
    loadDashboard();
  }, [cluster, school]);

  const loadDashboard = () => {
    axiosInstance
      .get("/metabase/compliancedashboard", { params: { cluster, school } })
      .then((res) => {
        setIframeUrl(res.data.url);
        setMode("dashboard");
      });
  };

  const loadDrilldown = (cardId) => {
    const qid = drilldownMap[activeTab][cardId];
    if (!qid) return;

    let params = {};

    if (activeTab === "cluster") {
      params.cluster = cluster;
    } else if (activeTab === "school") {
      params.cluster = cluster;
      params.school = school;
    }

    axiosInstance
      .get(`/metabase/compliancequestion/${qid}`, { params })
      .then((res) => {
        setIframeUrl(res.data.url);
        setMode("question");
      });
  };

  const positions = cardPositionsMap[activeTab];

  return (
    <div style={{ position: "relative" }}>
      {iframeUrl ? (
        <>
          <iframe
            src={iframeUrl}
            frameBorder="0"
            width="100%"
            height={1600}
            allowTransparency
            title="Metabase"
          />

          {mode === "dashboard" && (
            <>
              {Object.entries(positions).map(([id, pos]) => (
                <div
                  key={id}
                  onClick={() => loadDrilldown(id)}
                  style={{
                    position: "absolute",
                    ...pos,
                    cursor: "pointer",
                    zIndex: 20,
                  }}
                />
              ))}
              <div
                style={{
                  position: "absolute",
                  top: "0.2%",
                  left: "50%",
                  zIndex: 30,
                  display: "flex",
                  gap: "10px",
                }}
              >

                {/* ---------------COMPLAINCE DASHBOARD BUTTON------------ */}

                <button
                  onClick={() => setActiveTab("overall")}
                  style={{
                    padding: "6px 14px",
                    borderRadius: "6px",
                    border: "none",
                    background: activeTab === "overall" ? "#0072BB" : "#ccc",
                    color: activeTab === "overall" ? "white" : "black",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Overall
                </button>

                <button
                  onClick={() => setActiveTab("cluster")}
                  style={{
                    padding: "6px 14px",
                    borderRadius: "6px",
                    border: "none",
                    background: activeTab === "cluster" ? "#0072BB" : "#ccc",
                    color: activeTab === "cluster" ? "white" : "black",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Cluster
                </button>

                <button
                  onClick={() => setActiveTab("school")}
                  style={{
                    padding: "6px 14px",
                    borderRadius: "6px",
                    border: "none",
                    background: activeTab === "school" ? "#0072BB" : "#ccc",
                    color: activeTab === "school" ? "white" : "black",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  School
                </button>
              </div>
            </>
          )}

          {mode === "question" && (
            <button
              onClick={loadDashboard}
              style={{
                position: "absolute",
                top: 10,
                right: 20,
                background: "#0072BB",
                color: "white",
                padding: "6px 12px",
                borderRadius: 6,
                border: "none",
                cursor: "pointer",
                zIndex: 999,
              }}
            >
              ← Back to Compliance Dashboard
            </button>
          )}
        </>
      ) : (
        <p>Loading Compliance Dashboard...</p>
      )}
    </div>
  );
};

export default ComplianceMetabase;
